export const getFormFieldName = value => value.split('.').pop();

export const getFormFieldLabel = value => value.split(/\(?\*\)?/)[0];
